<!-- 信息维护 -->
<template>
  <div class=''>
    <register :id="supplierId"></register>
  </div>
</template>

<script>
import register from './Register.vue';

export default {
//import引入的组件需要注入到对象中才能使用
  components: {
    register
  },
  data() {
    return {
      supplierId: window.sessionStorage.getItem('loginId'),
    }
  },
//方法集合
  methods: {

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

},
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类

</style>


// WEBPACK FOOTER //
// src/pages/common/InfoEdit.vue